import { gql } from 'apollo-boost';

const dankaiListQuery = gql`
  query dankais($type: String) {
    dankais(type: $type) {
      id
      name
      label
      theme
      criteria
      type
      createdAt
      updatedAt
    }
  }
`;

const dankaiQuery = gql`
  query dankai($dankaiId: Int!) {
    dankai(dankaiId: $dankaiId) {
      id
      name
      label
      theme
      criteria
      type
      sections {
        id
        name
        description
        items {
          id
          name
          description
          tip
          link
        }
      }
    }
  }
`;

const dankaiUpdateMutation = gql`
  mutation updateDankai($id: Int!, $inputData: DankaiInputType!) {
    updateDankai(id: $id, inputData: $inputData) {
      ok
      errors {
        field
        messages
      }
      dankai {
        id
        name
        label
        theme
        criteria
        type
        sections {
          id
          name
          description
          items {
            id
            name
            description
            tip
            link
          }
        }
      }
    }
  }
`;

const generateDankaiPdfMutation = gql`
  mutation generateDankaiPdf($id: Int!) {
    generateDankaiPdf(id: $id) {
      ok
      errors {
        field
        messages
      }
      url
    }
  }
`;

const DANKAI = {
  dankaiListQuery,
  dankaiQuery,
  dankaiUpdateMutation,
  generateDankaiPdfMutation,
};

export default DANKAI;
